var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isHeader)?_c('th',[_vm._v("\n  "+_vm._s(_vm._f("translate")('Actions'))+"\n")]):_c('td',[_c('div',{staticClass:"custom-actions"},[_c('button',{staticClass:"btn btn-outline-secondary btn-sm mr-1",attrs:{"title":_vm.$t('Edit')},on:{"click":function($event){_vm.itemAction('edit', _vm.rowData, _vm.rowIndex)}}},[_c('i',{staticClass:"fa fa-edit"})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1487bc6d","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VueTableRiskActions.vue
// module id = 1321
// module chunks = 86